class ShareService {
  private map: Map<string, any>;

  constructor() {
    this.map = new Map();
  }

  setMapValue(key: string, value: any): void {
    this.map.set(key, value);
  }

  getMapValue(key: string): any | null {
    if (this.map.has(key)) {
      return this.map.get(key);
    }
    return null;
  }

  getMapValueAndRemove(key: string): any | null {
    if (this.map.has(key)) {
      const temp = this.map.get(key);
      this.map.delete(key);
      return temp;
    }
    return null;
  }

  deleteMapValue(key: string): void {
    if (this.map.has(key)) {
      this.map.delete(key);
    }
  }

  clearMap(): void {
    this.map.clear();
  }

  removeAllPageData(): void {
    for (const key of Array.from(this.map.keys())) {
      if (key.indexOf("page_") !== -1) {
        this.map.delete(key);
      }
    }
  }

}

// Export as a singleton — same instance across the whole app
const shareService = new ShareService();
export default shareService;